import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';

export const LearnMoreAboutPolicies: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Policy Blueprints', field: 'blueprints' },
    { label: 'Findings', field: 'findings' },
    { label: 'Exceptions', field: 'exceptions' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="policies"
      headerTitle="Policies"
      body={
        <Stack spacing={8}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Overview</Text>
            <Text>
              Policies are the foundations for all detection and enforcement in
              your cloud. Policies that need to be used to detect violation or
              to generate insights are stored in policy blueprints. Policy
              enforcement is done in environments to which policy blueprints are
              attached. We provide a large library of standard (Ariksa) policies
              out-of-the-box in Ariksa Best Practices. Additionally, compliance
              requirements are mapped to Ariksa policies as part of our policy
              blueprints for compliance standards such as SOC2, PCI DSS, NIST,
              CIS etc.
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Text fontWeight={600}>Lifecycle Management</Text>
            <Text>
              You can create custom policies to augment standard policies that
              are provided by Ariksa. Custom policies can help you detect
              violations or generate insights using context and information
              that’s specific to your organization and cloud. Custom and
              standard policies can be part of policy blueprints.
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Text fontWeight={600}>Exceptions</Text>
            <Text>
              Policy or resource exceptions are recorded within a policy
              blueprint. Policy exceptions are applied automatically to every
              environment to which the blueprint is attached. However, resource
              exceptions are limited to the specific resource (and the
              environment in which the resource is deployed) to which it
              applied.
            </Text>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
